/* eslint-disable linebreak-style */
/* eslint-disable eqeqeq */
import { CREATE_NEW_USER } from '../../constants/common.const';
import i18n from '../../i18n';
import { NOT_FOUND_ERRORS } from './constants';
import errorHandler from './errorHandler';

const successHandler = (response) => {
  const status = response?.status;
  // Normalize response data to a comparable string
  const rawData = response?.data;
  const dataString = typeof rawData === 'string'
    ? rawData
    : (rawData?.messages?.[0]?.message
      || rawData?.messages?.[0]?.['debug-message']
      || rawData?.message
      || '');
  const normalized404Text = String(dataString).toLowerCase().trim();
  const isItemNotFound404 = status == 404 && NOT_FOUND_ERRORS.some(msg => normalized404Text?.includes(msg));
  const isCreateNewUserFunction = status == 400 && response?.config?.functionName === CREATE_NEW_USER;

  if ((status != 403
    && response?.data != i18n.t('Access to the specified resource is forbidden.'))
    && status != 401 && status != 500
    && (status != 409 || ((response?.data?.messages?.[0]?.id === 'address.suggestion' || response?.data?.messages?.[0]?.id === 'address.invalid' || response?.data?.messages?.[0]?.id === 'placeOrder.checkout.popup.body.message.ground' || response?.data?.messages?.[0]?.id === 'placeOrder.checkout.popup.body.message.air' || response?.data?.messages?.[0]?.id === 'placeorder.shipping.restrictions') && status == 409))
    && response !== undefined && (status != 400 || isCreateNewUserFunction)
    && (status != 404 || isItemNotFound404)
    && status != 422
  ) {
    return response;
  }
  return errorHandler({ response });
};
export default successHandler;
